import type { PunchEcho } from '../types';

interface PunchEchoCardProps {
  echo: PunchEcho | null;
}

/**
 * Shows the outcome of the most recent punch: a pending state while it syncs,
 * then the authoritative server result (employee name + clocked_in/out/switched),
 * or a rejection (e.g. unrecognized PIN). Renders nothing when idle.
 */
export function PunchEchoCard({ echo }: PunchEchoCardProps): JSX.Element | null {
  if (echo === null) {
    return null;
  }

  const className = echo.rejected
    ? 'echo echo--error'
    : echo.pending
      ? 'echo echo--pending'
      : 'echo echo--ok';

  return (
    <div className={className} role="status" aria-live="polite">
      {echo.message}
    </div>
  );
}
